import {DeleteProfileBloggerFormField} from "../types/delete-profile-blogger-modal.types";

export const deleteProfileBloggerModalName = 'delete-profile-blogger';

export const deleteProfilesBloggerFormFields: Array<DeleteProfileBloggerFormField> = [
  {
    label: 'Ссылка на профиль',
    fieldName: 'url'
  }
];
